module.exports = __webpack_public_path__ + "assets/img/hontoyutari-photo02.07777218.jpg";